import { render, staticRenderFns } from "./FSwitches.vue?vue&type=template&id=c0922f0c&"
import script from "./FSwitches.vue?vue&type=script&lang=js&"
export * from "./FSwitches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports